import { REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = {
  lastLevelUnlocked: 0,
};

const screenReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LAST_LEVEL_UNLOCKED:
      return {
        ...state,
        lastLevelUnlocked: payload,
      };

    default:
      return state;
  }
};

export default screenReducer;
